"use strict";

angular.module("customer")
.controller("OrderTemplateListController", function(
    $scope, $state, $stateParams, Language, common, StateExtensionService, OrderTemplateService, UserService,
    UserTypeService
) {
    Language.initializeScope($scope, "language", "locale");
    $scope.weekdays = common.getISOWeekdays($scope.locale);

    $scope.$on("LanguageChanged", function(obj, locale) {
        $scope.weekdays = common.getISOWeekdays(locale);
    });

    $scope.pagination = {};
    $scope.params = angular.extend({}, $stateParams);

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
        }
    });

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.fetch();
    };

    this.fetch = function() {
        OrderTemplateService.query($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.orderTemplates = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    };

    this.getStandingOrderDeliveryWeekdays = function(weekdays) {
        var weekdayNames = [];
        angular.forEach(weekdays, function(weekday) {
            weekdayNames.push($scope.weekdays[weekday]);
        });
        return weekdayNames.join(", ");
    };

    this.seeDetails = function(id) {
        $state.go("orderTemplateDetails", {id: id});
    };

    this.getStandingOrderAvailableDeliveryWeekdays = function(selectedWeekdays, availableWeekdays) {
        return OrderTemplateService.getStandingOrderAvailableDeliveryWeekdays($scope.weekdays, selectedWeekdays, availableWeekdays);
    };

    this.getStandingOrderUnavailableDeliveryWeekdays = function(selectedWeekdays, availableWeekdays) {
        return OrderTemplateService.getStandingOrderUnavailableDeliveryWeekdays($scope.weekdays, selectedWeekdays, availableWeekdays);
    };

    $scope.userTypeNames = UserTypeService.getUserTypeNamesTranslations();

    this.fetch();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order-template/order-template-list.controller.js
// module id = 967
// module chunks = 0